var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 49,
    viewBox: "0 0 37 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8334 4.08337H4.20837V2.04163C4.20837 0.912625 3.29574 0 2.16663 0C1.03763 0 0.125 0.912625 0.125 2.04163V6.125V30.625V46.9584C0.125 48.0874 1.03763 49 2.16663 49C3.29564 49 4.20827 48.0874 4.20827 46.9584V32.6666H34.8333C35.9623 32.6666 36.8749 31.754 36.8749 30.625V6.125C36.875 4.99599 35.9624 4.08337 34.8334 4.08337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.f0d2855c5414219dc88fbe6513336953.svg";
export { ForwardRef as ReactComponent };